// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as GAUtils from "../../../library/ga/GAUtils.bs.js";
import * as GAEvents from "../../../library/ga/GAEvents.bs.js";
import * as EventUtils from "../../../library/partner-app-events/EventUtils.bs.js";
import * as RnrAssetManager from "../assets/RnrAssetManager.bs.js";
import * as BackgroundImageCmp from "./img-swiper/BackgroundImageCmp.bs.js";
import * as Languages$Catalyst from "../../../../node_modules/@porterin/catalyst/src/entities/vernacular/Languages.bs.js";
import * as PartnerAppEventsConfig from "../../../library/partner-app-events/PartnerAppEventsConfig.bs.js";

var banner_english = RnrAssetManager.getImage("lending_banner_english.png");

var banner_hindi = RnrAssetManager.getImage("lending_banner_hindi.png");

var banner_kannada = RnrAssetManager.getImage("lending_banner_kannada.png");

var banner_tamil = RnrAssetManager.getImage("lending_banner_tamil.png");

var banner_telugu = RnrAssetManager.getImage("lending_banner_telugu.png");

var banner_marathi = RnrAssetManager.getImage("lending_banner_marathi.png");

function banner_image(lang) {
  var match = Languages$Catalyst.fromCode(lang);
  switch (match) {
    case /* English */0 :
        return banner_english;
    case /* Hindi */1 :
        return banner_hindi;
    case /* Kannada */2 :
        return banner_kannada;
    case /* Tamil */3 :
        return banner_tamil;
    case /* Telugu */4 :
        return banner_telugu;
    case /* Marathi */5 :
        return banner_marathi;
    case /* Malayalam */6 :
    case /* Bangla */7 :
        throw {
              RE_EXN_ID: "Match_failure",
              _1: [
                "RnrLendingBannerCmp.res",
                9,
                2
              ],
              Error: new Error()
            };
    
  }
}

function RnrLendingBannerCmp(Props) {
  var banner = Props.banner;
  var uuid = Props.uuid;
  var lang = Props.lang;
  var version = Props.version;
  React.useEffect((function () {
          GAEvents.publishEvent("rnr", "Award-Section/Lending-Banner<Displayed>", undefined, GAUtils.labelString([
                    banner.name,
                    uuid
                  ]), undefined, undefined);
          
        }), []);
  return React.createElement(BackgroundImageCmp.make, {
              on_click: (function (_event) {
                  var url = banner.url;
                  var event_label = banner.name;
                  EventUtils.sendEventToPartnerApp(PartnerAppEventsConfig.banner_card_clicked, undefined, event_label, undefined, undefined, undefined, undefined, undefined);
                  GAEvents.publishEvent("rnr", "Award-Section/Promo-Banner<Clicked>", undefined, GAUtils.labelString([
                            event_label,
                            uuid
                          ]), undefined, undefined);
                  var utmLoadedUrl = url + ("&utm_source=RNR&utm_medium=RNR_Page_Banner&utm_content=banner&lang=" + lang + "&uuid=" + uuid + "&version_name=" + version);
                  window.open(utmLoadedUrl, "_parent");
                  
                }),
              class_name: "award-card-component__container insurance-banner",
              image_url: banner_image(lang)
            });
}

var make = RnrLendingBannerCmp;

export {
  banner_english ,
  banner_hindi ,
  banner_kannada ,
  banner_tamil ,
  banner_telugu ,
  banner_marathi ,
  banner_image ,
  make ,
  
}
/* banner_english Not a pure module */
